import pdfIcon from "../../assets/images/icons/filetypes/pdf-icon.png";
import xlsIcon from "../../assets/images/icons/filetypes/xls-icon.png";
import wordIcon from "../../assets/images/icons/filetypes/word-doc-icon.png";
import txtIcon from "../../assets/images/icons/filetypes/txt-icon.png";
import zipIcon from "../../assets/images/icons/filetypes/zip-icon.png";
import jpgIcon from "../../assets/images/icons/filetypes/jpg-icon.png";
import pngIcon from "../../assets/images/icons/filetypes/png-icon.png";
import Translate from "../../common/functions/translate";
import { Lang, UserConditionType } from "../enums";

export function getIconByFileType(fileType: string) {
  switch (fileType.toLowerCase()) {
    case "pdf":
      return pdfIcon;
    case "xls":
    case "xlsx":
      return xlsIcon;
    case "doc":
    case "docx":
      return wordIcon;
    case "txt":
      return txtIcon;
    case "zip":
      return zipIcon;
    case "jpg":
      return jpgIcon;
    case "png":
      return pngIcon;
  }
}

export function clone(item) {
  return (
    // return cloned copy so that the item is passed by value instead of by reference
    JSON.parse(JSON.stringify(item))
  );
}

export function getErrorMessage(error) {
  if (error.response) {
    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.ErrorCode
    ) {
      return { message: Translate(`${error.response.data.Data.ErrorCode}`) };
    }

    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.Message
    ) {
      return { message: `${error.response.data.Data.Message}` };
    }

    if (error.response.data) {
      return { message: Translate(`${error.response.data}`) };
    }

    return { message: `${error.response.status} ${error.response.statusText}` };
  } else {
    return { message: Translate(`${error.message}`) };
  }
}

export function getQueryStringParams(query: string) {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
      .split("&")
      .reduce((params, param) => {
        let [key, value] = param.split("=");
        params[key] = value
          ? decodeURIComponent(value.replace(/\+/g, " "))
          : "";
        return params;
      }, {})
    : {};
}

export function createDrugToDrugQueryString(
  firstId: number,
  typeId: number,
  secondId: number
) {
  return `?firstId=${firstId}&typeId=${typeId}&secondId=${secondId}`;
}

//Groups array by objects property and returns object of arrays
export function groupByReturnObject(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

//Groups array by objects property and returns array of arrays
export function groupByReturnArray(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    var key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, []);
}

export function formatBytes(bytes, decimals) {
  if (bytes == 0) return "0 Bytes";
  var k = 1024,
    dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function fomatDateAsString(date: Date) {
  return (
    date.getFullYear().toString() +
    "-" +
    (date.getMonth() < 9
      ? "0" + (date.getMonth() + 1).toString()
      : (date.getMonth() + 1).toString()) +
    "-" +
    (date.getDate() < 10
      ? "0" + date.getDate().toString()
      : date.getDate().toString())
  );
}

export function fomatDateAsStringNotifications(date: Date) {
  return (
    date.getFullYear().toString() +
    "/" +
    (date.getMonth() < 9
      ? "0" + (date.getMonth() + 1).toString()
      : (date.getMonth() + 1).toString()) +
    "/" +
    (date.getDate() < 10
      ? "0" + date.getDate().toString()
      : date.getDate().toString())
  );
}

export function fomatDatesStringWithLang(date: Date, lang: string) {
  switch (lang) {
    case "bg":
      return (
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "." +
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "." +
        date.getFullYear().toString() +
        " г."
      );

    case "en":
      return (
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "/" +
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "/" +
        date.getFullYear().toString()
      );
  }
}

export function fomatDateTimeAsString(date: Date) {
  return (
    date.getFullYear().toString() +
    "/" +
    (date.getMonth() < 9
      ? "0" + (date.getMonth() + 1).toString()
      : (date.getMonth() + 1).toString()) +
    "/" +
    (date.getDate() < 10
      ? "0" + date.getDate().toString()
      : date.getDate().toString()) +
    " " +
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2) +
    ":" +
    ("0" + date.getSeconds()).slice(-2)
  );
}

export function fomatDateTimeAsStringWithLang(date: Date, lang: string) {
  switch (lang) {
    case "bg":
      return (
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "." +
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "." +
        date.getFullYear().toString() +
        " г. " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2)
      );

    case "en":
      return (
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "/" +
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "/" +
        date.getFullYear().toString() +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2)
      );
  }
}

export function fomatDateTimeSecondsAsStringWithLang(date: Date, lang: string) {
  switch (lang) {
    case "bg":
      return (
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "." +
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "." +
        date.getFullYear().toString() +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2) +
        ":" +
        ("0" + date.getSeconds()).slice(-2)
      );

    case "en":
      return (
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "/" +
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "/" +
        date.getFullYear().toString() +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2) +
        ":" +
        ("0" + date.getSeconds()).slice(-2)
      );
  }
}

export function fomatDateAsStringWithLang(date: Date, lang: string) {
  switch (lang) {
    case "bg":
      return (
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "." +
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "." +
        date.getFullYear().toString() +
        " г."
      );

    case "en":
      return (
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "/" +
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "/" +
        date.getFullYear().toString()
      );

    default:
      return (
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "." +
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "." +
        date.getFullYear().toString() +
        " г."
      );
  }
}

export function fomatTimeAsString(date: Date) {
  return (
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2) +
    ":" +
    ("0" + date.getSeconds()).slice(-2)
  );
}

export function fomatTimeAsStringWithoutSeconds(date: Date) {
  return (
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2)
  );
}

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function enumToDropdownArray(enumName, withTranslation?: boolean) {
  let enumAsArray: Array<{ value: number; label: string }> = [];
  for (var n in enumName) {
    if (typeof enumName[n] === "number") {
      enumAsArray.push({
        value: +enumName[n],
        label: withTranslation ? Translate(n) : n
      });
    }
  }
  return enumAsArray;
}

export function weekDayEnumToObjArray(
  enumName,
  withTranslation?: boolean,
  dayValueFromOne?: boolean,
  allSelected?: boolean
) {
  let enumAsArray: Array<{
    value: number;
    label: string;
    isSelected: boolean;
  }> = [];
  for (var n in enumName) {
    if (typeof enumName[n] === "number") {
      enumAsArray.push({
        value: +enumName[n] + (dayValueFromOne ? 1 : 0),
        label: withTranslation ? Translate(n) : n,
        isSelected: allSelected ? allSelected : false
      });
    }
  }
  return enumAsArray;
}

export function getEnumLabel(
  id: number,
  enumName: any,
  withTranslation?: boolean
) {
  let enumElement = Object.keys(enumName).find(key => enumName[key] === id);

  if (withTranslation) {
    return Translate(enumElement);
  } else {
    return enumElement;
  }
}

export function getFrequencyCounterLabel(
  value?: number,
  withTranslation?: boolean
) {
  switch (value) {
    case 1:
      return withTranslation
        ? Translate("Recurs every") + " " + Translate("hour(s)")
        : Translate("Recurs every");
    case 2:
      return withTranslation
        ? Translate("Recurs every") + " " + Translate("day(s)")
        : Translate("Recurs every");
    case 3:
      return withTranslation
        ? Translate("Recurs every(f)") + " " + Translate("week(s)")
        : Translate("Recurs every");
    case 4:
      return withTranslation
        ? Translate("Recurs every") + " " + Translate("month(s)")
        : Translate("Recurs every");
    default:
      return withTranslation ? Translate("Recurs every") : "Recurs every";
  }
}

export function fomatTimeWithoutSecondsAsString(date: Date) {
  return (
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2)
  );
}

export function fomatTimeStringWithoutSecondsAsString(time: string) {
  return time.slice(0, 5);
}

export function formatAlarmTime(alarmTime: any) {
  if (typeof alarmTime === "string") {
    if (alarmTime.length > 8) {
      return fomatTimeWithoutSecondsAsString(new Date(alarmTime));
    } else {
      return fomatTimeStringWithoutSecondsAsString(alarmTime);
    }
  } else {
    return fomatTimeWithoutSecondsAsString(new Date(alarmTime));
  }
}

export function getNotificationSummary(
  currentUserNotification: any,
  lang: string
) {
  let summaryContent = "";
  let alarmTime = formatAlarmTime(currentUserNotification.alarmTime);

  if (currentUserNotification.notificationScheduleTypeId === 1) {
    let oneTimeExecutionDate = "";
    if (currentUserNotification.oneTimeExecutionDate) {
      oneTimeExecutionDate = fomatDateAsStringWithLang(
        new Date(currentUserNotification.oneTimeExecutionDate),
        lang
      );
    } else {
      oneTimeExecutionDate = fomatDateAsStringWithLang(new Date(), lang);
    }

    summaryContent =
      Translate("On") +
      " " +
      oneTimeExecutionDate +
      " " +
      Translate("at") +
      " " +
      alarmTime +
      ".";
    return summaryContent;
  } else {
    let startDate = "";
    if (currentUserNotification.startDate) {
      startDate = fomatDateAsStringWithLang(
        new Date(currentUserNotification.startDate),
        lang
      );
    } else {
      startDate = fomatDateAsStringWithLang(new Date(), lang);
    }

    let endDate = "";
    if (currentUserNotification.endDate) {
      endDate = fomatDateAsStringWithLang(
        new Date(currentUserNotification.endDate),
        lang
      );
    }

    let periodLabel = "";
    if (currentUserNotification.notificationFrequencyCounter) {
      switch (currentUserNotification.notificationFrequencyId) {
        case 1:
          periodLabel =
            currentUserNotification.notificationFrequencyCounter > 1
              ? currentUserNotification.notificationFrequencyCounter +
              " " +
              Translate("hour(s)")
              : Translate("hour");
          break;
        case 2:
          periodLabel =
            currentUserNotification.notificationFrequencyCounter > 1
              ? currentUserNotification.notificationFrequencyCounter +
              " " +
              Translate("day(s)")
              : Translate("day");
          break;
        case 3:
          periodLabel =
            currentUserNotification.notificationFrequencyCounter > 1
              ? currentUserNotification.notificationFrequencyCounter +
              " " +
              Translate("week(s)")
              : Translate("week");
          break;
        case 4:
          periodLabel =
            currentUserNotification.notificationFrequencyCounter > 1
              ? currentUserNotification.notificationFrequencyCounter +
              " " +
              Translate("month(s)")
              : Translate("month");
          break;
      }
    }

    if (endDate) {
      summaryContent =
        Translate("Every") +
        " " +
        periodLabel +
        " " +
        (currentUserNotification.notificationFrequencyId === 1
          ? Translate("from")
          : Translate("at")) +
        " " +
        alarmTime +
        ", " +
        Translate("between") +
        " " +
        startDate +
        " " +
        Translate("and") +
        " " +
        endDate +
        (lang === "bg" ? "" : ".");
    } else {
      summaryContent =
        Translate("Every") +
        " " +
        periodLabel +
        " " +
        (currentUserNotification.notificationFrequencyId === 1
          ? Translate("from")
          : Translate("at")) +
        " " +
        alarmTime +
        ", " +
        Translate("starting on") +
        " " +
        startDate +
        (lang === "bg" ? "" : ".");
    }
  }

  return summaryContent;
}

export function urlB64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function getURLParameter(name) {
  var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
    window.location.href
  );
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
}

export function getLangId(lang: string) {
  switch (lang) {
    case "bg":
      return Lang.bg;
    case "en":
      return Lang.en;
  }
}

export function formatDateToUTC(dateString) {
  var date = new Date(dateString);
  date.setHours(0, 0, 0);
  return date.toUTCString();
}

export function getUnitByConditionType(condType: UserConditionType) {
  switch (condType) {
    case UserConditionType.Height:
      return "cm";
    case UserConditionType.Weight:
      return "kg";
    case UserConditionType.BloodPressure:
      return "mmHg";
    case UserConditionType.HeartRate:
      return "bpm";
    case UserConditionType.Temperature:
      return "C";
    case UserConditionType.BloodSugar:
      return "mmol/L";
    default:
      return "";
  }
}

export function getMonthsEarlier(currentDate: string, months: number) {
  let d = new Date(currentDate);
  d.setMonth(d.getMonth() - months);
  return d;
}

export function getDaysEarlier(currentDate: string, days: number) {
  let d = new Date(currentDate);
  d.setDate(d.getDate() - days);
  return d;
}

export function getDayslater(currentDate: string, days: number) {
  let d = new Date(currentDate);
  d.setDate(d.getDate() + days);
  return d;
}
